import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/Login';
import OptionsPage from './pages/Options';
import Treinamento from './pages/Treinamento';
import Cancelamento from './pages/Cancelamento';
import CancelamentoObs from './pages/CancelamentoObs';
import TreinamentoObs from './pages/TreinamentoObs';
import PrivateRoute from './components/routes/PrivateRoute';


function App() {

  return (
    <div className="App">
      <main className="content">
          <Router>
            <Routes>
              <Route path='/' element={<LoginPage />}/>
              <Route path='/options' element={
              <PrivateRoute>
                <OptionsPage />
              </PrivateRoute>
              }/>
              <Route path='/treinamento' element={
              <PrivateRoute>
                <Treinamento />
              </PrivateRoute>
              }/>
              <Route path='/cancelamento' element={
              <PrivateRoute>
                <Cancelamento />
              </PrivateRoute>
              }/>
              <Route path='/cancelamento/:idUnidade' element={
              <PrivateRoute>
                <CancelamentoObs />
              </PrivateRoute>
              }/>
              <Route path='/treinamento/:idUnidade' element={
              <PrivateRoute>
                <TreinamentoObs />
              </PrivateRoute>
              }/>
            </Routes>
          </Router>
        </main>
    </div>
  );
}

export default App;
